module.exports = __webpack_public_path__ + "static/media/whoweare_section2_onelayer.7886eb98.png";